import React from "react";
import { Grid, Row, Col, Nav } from "react-bootstrap";
import { Switch, Route, Redirect } from "react-router";

import AlmigLink from "../grundelemente/AlmigLink";
import BreadcrumbContainer from "../grundelemente/BreadcrumbContainer";
import OnlyTimeInfoPanel from "../grundelemente/OnlyTimeInfoPanel";

import ErrorlogContainer from "./ErrorlogContainer";
import DatenlogsContainer from "./DatenlogsContainer";
import EnergieBilanzContainer from "./EnergieBilanzContainer";
import "./Datenarchiv.css";

import EnergieverbrauchContainer from "./EnergieverbrauchContainer";
import VolumenUndLeckageContainer from "./VolumenUndLeckageContainer";
import ThinkGreenInfoPanelContainer from "./ThinkGreenInfoPanelContainer";
import WaermerueckgewinnungContainer from "./WaermerueckgewinnungContainer";
import WaermerueckgewinnungParameterContainer from "./WaermerueckgewinnungParameterContainer";

const Energiebilanzierung = () => (
	<Grid className="DatenArchiv">
		<Row>
			<Col xs={12}>
				<BreadcrumbContainer />
			</Col>
		</Row>
		<Row>
			<Col sm={12} md={3}>
				<Nav stacked className="Navispalte">
					<AlmigLink to="/energy_balancing/energy_balance" />     {/* /data_archive/energy_balance */}
					<AlmigLink to="/energy_balancing/energy_consumption" /> {/* /think_green/energy_consumption */}
					<AlmigLink to="/energy_balancing/volume_and_leakage" /> {/* /think_green/volume_and_leakage */}
					<AlmigLink to="/energy_balancing/heat_reclaiming" />    {/* /think_green/heat_reclaiming */}
					{/*<AlmigLink to="/energy_balancing/error_log" />*/}    {/* /data_archive/error_log */}
					<AlmigLink to="/energy_balancing/data_logs" />          {/* /data_archive/data_logs */}
				</Nav>
				<Switch>
					<Route path="/energy_balancing/heat_reclaiming" component={WaermerueckgewinnungParameterContainer} />
				</Switch>
			</Col>
			<Col sm={12} md={6} className="Mittelspalte">
				<Switch>
					<Route path="/energy_balancing/energy_balance" component={EnergieBilanzContainer} />
					<Route path="/energy_balancing/energy_consumption" component={EnergieverbrauchContainer} />
					<Route path="/energy_balancing/volume_and_leakage" component={VolumenUndLeckageContainer} />
					<Route path="/energy_balancing/heat_reclaiming" component={WaermerueckgewinnungContainer} />
					<Route path="/energy_balancing/error_log" component={ErrorlogContainer} />
					<Route path="/energy_balancing/data_logs" component={DatenlogsContainer} />
					<Redirect exact from="/energy_balancing" to="/energy_balancing/energy_consumption" />
				</Switch>
			</Col>
			<Col sm={12} md={3}>
				<Switch>
					<Route path="/energy_balancing/energy_balance" component={OnlyTimeInfoPanel} />
					<Route path="/energy_balancing/energy_consumption" component={ThinkGreenInfoPanelContainer} />
					<Route path="/energy_balancing/volume_and_leakage" component={ThinkGreenInfoPanelContainer} />
					<Route path="/energy_balancing/heat_reclaiming" component={ThinkGreenInfoPanelContainer} />
					<Route path="/energy_balancing/error_log" component={OnlyTimeInfoPanel} />
					<Route path="/energy_balancing/data_logs" component={OnlyTimeInfoPanel} />
				</Switch>
			</Col>
		</Row>
	</Grid>
);

export default Energiebilanzierung;